import axios from 'axios';
import { baseUrl } from '@/config';

export default {
  /**
   * [네트워크 설정 > IP 대역 관리]
   * @author Song
   * @return {[type]}   [description]
   */
  getIpUseList(params) {
    return axios.post(`${baseUrl}/settings/netdevice-ip-management/get-ip-use-list.do`, params);
  },
  /**
   * IP 대역관리 > IP 클릭 > IP 상태 현황 조회
   * @author Song
   * @return {[type]}   [description]
   */
  getNetStatusList(params) {
    return axios.post(`${baseUrl}/settings/netdevice-ip-management/get-net-status-list.do`, params);
  },
  /**
   * IP 대역관리 > IP 대역 리스트 조회
   * @author Song
   * @return {[type]}   [description]
   */
  getNetIpBandList(params) {
    return axios.post(`${baseUrl}/settings/netdevice-ip-management/get-ip-band-list.do`, params);
  },
  /**
   * IP 대역관리 > IP 대역 리스트 조회 > subnetmask oderbyIndex 정렬 조회
   * @author Song
   * @return {[type]}   [description]
   */
  getSubnetmaskList() {
    return axios.get(`${baseUrl}/settings/netdevice-ip-management/get-subnetmask-list.do`);
  },
  /**
   * IP 대역관리 > IP 대역 리스트 조회 > ip 주소를 subnetbit에 따라 대역폭을 구한다.
   * @author Song
   * @return {[type]}   [description]
   */
  getDHCPList(params) {
    return axios.post(`${baseUrl}/settings/netdevice-ip-management/get-dhcp-list.do`, params);
  },
  /**
   * IP 대역관리 > IP 대역 리스트 조회 > IP 대역을 추가한다.
   * @author Song
   * @return {[type]}   [description]
   */
  insertNcmIpBandList(params) {
    return axios.post(`${baseUrl}/settings/netdevice-ip-management/insert-ip-band-list.do`, params);
  },
  /**
   * IP 대역관리 > IP 대역 리스트 조회 > IP 대역 정보를 수정한다.
   * @author Song
   * @return {[type]}   [description]
   */
  updateNcmIpBandList(params) {
    return axios.post(`${baseUrl}/settings/netdevice-ip-management/update-ip-band-list.do`, params);
  },
  /**
   * IP 대역관리 > IP 대역 리스트 조회 > IP 대역을 삭제한다.
   * @author Song
   * @return {[type]}   [description]
   */
  deleteNcmIpBandList(params) {
    return axios.post(`${baseUrl}/settings/netdevice-ip-management/delete-ip-band-list.do`, params);
  },
};



// WEBPACK FOOTER //
// ./src/api/settings/netdevice/netdevice-ip-management.js